import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { CustomerTicketSummary } from './models/customer-ticket-summary.model';
import { GameService } from "./game.service";

// Resolver for game with ticket
export function gameWithTicketResolver(): ResolveFn<CustomerTicketSummary[] | undefined>{
  return (route: any, state: any) => {
    const gameService: GameService = inject(GameService);
    return gameService.fetchGamesWithTickets().toPromise();
  }
};
